// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"dba9ea6d","348":"1689c932","398":"1ac76c44","883":"4aa1d6b9"}[chunkId] + ".chunk.js";
};